import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";

export default function Layout({ minimal = false }) {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        if (hash) {
            setTimeout(() => {
                const el = document.getElementById(hash.slice(1));
                if (el) {
                    el.scrollIntoView({ behavior: "smooth", block: "start" });
                    return;
                }
                window.scrollTo({ top: 0, behavior: "instant" });
            }, 80);
        } else {
            window.scrollTo({ top: 0, behavior: "instant" });
        }
    }, [pathname, hash]);

    return (
        <div className="min-h-screen flex flex-col bg-background">
            {!minimal && <Header />}
            <main className="flex-1" data-testid="page-main">
                <Outlet />
            </main>
            {!minimal && <Footer />}
        </div>
    );
}
